import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "unmanaged-business" }
const _hoisted_2 = { class: "unmanaged-business__title" }
const _hoisted_3 = { class: "unmanaged-business__header" }
const _hoisted_4 = { class: "unmanaged-business__header-filetype" }
const _hoisted_5 = {
  key: 0,
  class: "unmanaged-business__table-container"
}
const _hoisted_6 = { class: "unmanaged-business__filter-pagination-container" }
const _hoisted_7 = { class: "modal__body-container" }
const _hoisted_8 = { class: "modal__body-container modal__body-container-announce" }
const _hoisted_9 = { class: "modal__selection modal__selection-announce" }
const _hoisted_10 = { class: "modal__body-container modal__body-container-inventory" }
const _hoisted_11 = { class: "modal__body-container" }

import ControlPageTab from '@/corePagesModule/components/ControlPageTab.vue';
import { useUnmanagedBusinessStore } from '@/unmanagedBusinessModule/pages/unmanagedBusinessStore';
import { storeToRefs } from 'pinia';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import { ImportFileType } from '@/coreDomainsModule/entities/unmanagedBusiness';
import FileTypeSelectButton from '../components/FileTypeSelectButton.vue';
import { i18n } from '@/i18n';
import RegisterUnmanagedBusinessModal from '../components/RegisterUnmanagedBusinessModal.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { UnmanagedBusinessService } from '../domains/services/UnmanagedBusinessService';
import Button from '@/components/input/Btn/Btn.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { onMounted } from 'vue';
import SelectInput from '@/corePagesModule/components/SelectInput.vue';
import AppDatePicker from '@/corePagesModule/components/AppDatePicker.vue';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import { isLoading } from '@/coreDomainsModule/uiLoadingState';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import RegisterUpdateInfoModal from '../components/RegisterUpdateInfoModal.vue';
import RegisterLeadTimeAndEtcModal from '../components/RegisterLeadTimeAndEtcModal.vue';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import { FilterModalType } from '@/corePagesModule/filterModal/filterModal';
import { assertNever } from '@/coreDomainsModule/assertNever';
import { TableContentProperty } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.t;
const locale = i18n.locale;
const store = useUnmanagedBusinessStore();
const { state } = storeToRefs(store);
const {
  fetchUnmanagedBusinesses,
  openModal,
  closeModal,
  deleteCheckedUnmanagedBusiness,
  getTableType,
  openModalByPreviousModal,
  onAppliedFilterModal,
  sortTableContentItems,
  summaryGetFilterItemValue,
} = store;
/**
 * 年の選択肢（2014年から2034年まで）
 */
const yearOptions = Array.from({ length: 2034 - 2014 + 1 }, (_, i) => (2014 + i).toString());

/**
 * ページング変更時の処理
 * @param pagingOptions - ページングオプション
 */
const onChangePaging = async (pagingOptions: IPagingOptions) => {
  state.value.tableInfo[state.value.selectedFileType].pagingState = pagingOptions;
  await fetchUnmanagedBusinesses();
};

/**
 * フィルターモーダルの種類を取得
 * @param fileType - ファイルタイプ
 * @returns フィルターモーダルの種類
 */
const getFilterModalType = (fileType: ImportFileType): FilterModalType => {
  switch (fileType) {
    case ImportFileType.Announce:
      return 'unmanagedBusinessTypeAnnounce';
    case ImportFileType.Inventory:
      return 'unmanagedBusinessTypeInventory';
    case ImportFileType.SalesResult:
      return 'unmanagedBusinessTypeSalesResult';
    case ImportFileType.Arrival:
      return 'unmanagedBusinessTypeArrival';
    default:
      return assertNever(fileType);
  }
};

onMounted(async () => {
  await fetchUnmanagedBusinesses();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('管理表')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ControlPageTab),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ImportFileType), (fileType) => {
          return (_openBlock(), _createBlock(FileTypeSelectButton, {
            key: fileType,
            "file-type": fileType
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)(`ImportFileType:${fileType}`)), 1)
            ], undefined, true),
            _: 2
          }, 1032, ["file-type"]))
        }), 128))
      ]),
      _createVNode(Button, {
        class: "unmanaged-business__header-delete-button",
        "button-style": "btn-primary",
        disabled: _unref(state).checkedIds[_unref(state).selectedFileType].length === 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openModal)('delete')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('削除')) + " ", 1),
          _createVNode(SvgLoader, { name: "trashIcon" })
        ], undefined, true),
        _: 1
      }, 8, ["disabled"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ImportFileType), (fileType) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: fileType }, [
        (_unref(state).selectedFileType === fileType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_unref(state).selectedFileType === fileType)
                  ? (_openBlock(), _createBlock(FilterModalButton, {
                      key: 0,
                      "filter-modal-type": getFilterModalType(fileType),
                      "select-input-index": 10,
                      "filter-items": _unref(summaryGetFilterItemValue)[fileType]().value,
                      onApply: _cache[1] || (_cache[1] = (filteredContents) => _unref(onAppliedFilterModal)(filteredContents))
                    }, null, 8, ["filter-modal-type", "filter-items"]))
                  : _createCommentVNode("", true),
                _createVNode(Pagination, {
                  "paging-options": _unref(state).tableInfo[fileType].pagingState,
                  "is-loading": _unref(isLoading)(_unref(state).tableInfo[fileType].loadingState.status),
                  onOnChangePage: onChangePaging
                }, null, 8, ["paging-options", "is-loading"])
              ]),
              (_openBlock(), _createBlock(NewBaseTableContent, {
                key: fileType,
                "prop-table-content-properties": _unref(state).tableInfo[fileType].tableContentProperties,
                "prop-display-objects": _unref(state).tableInfo[fileType].tableContentItems,
                "prop-loading-status": _unref(state).tableInfo[fileType].loadingState,
                "prop-table-type": _unref(getTableType)(fileType),
                "prop-is-reset": _unref(state).tableInfo[fileType].isReset,
                class: "",
                onChecked: ($event: any) => (_unref(state).checkedIds[fileType] = $event),
                onOnClickSort: _cache[2] || (_cache[2] = (sortKey, isAsc) => _unref(sortTableContentItems)(sortKey, isAsc)),
                onReload: _cache[3] || (_cache[3] = ($event: any) => (_unref(fetchUnmanagedBusinesses)()))
              }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status", "prop-table-type", "prop-is-reset", "onChecked"]))
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    _createVNode(RegisterUnmanagedBusinessModal),
    _createVNode(RegisterUpdateInfoModal),
    _createVNode(RegisterLeadTimeAndEtcModal),
    _createVNode(InfoModal, {
      icon: "error",
      "color-style": "error",
      "modal-state": _unref(state).modalInfo.isOpen.delete,
      "back-button-label": _unref(t)('キャンセル'),
      "next-button-label": _unref(t)('削除'),
      onOnBack: _cache[4] || (_cache[4] = ($event: any) => (_unref(closeModal)('delete'))),
      onOnNext: _cache[5] || (_cache[5] = ($event: any) => (_unref(deleteCheckedUnmanagedBusiness)()))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('未管理取引を削除します')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('在庫管理していない取引を消去します。')) + " ", 1),
        _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('よろしいですか？')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"]),
    _createVNode(InfoModal, {
      icon: "info",
      "modal-state": _unref(state).modalInfo.isOpen.noDuplication,
      "back-button-label": _unref(t)('戻る'),
      "next-button-label": _unref(t)('登録する'),
      onOnBack: _cache[6] || (_cache[6] = ($event: any) => (_unref(openModal)('registerBusiness'))),
      onOnNext: _cache[7] || (_cache[7] = ($event: any) => (_unref(openModalByPreviousModal)('noDuplication')))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('重複取引はありません')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('重複取引が検出されなかったため、')) + " ", 1),
        _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('追記した取引を登録することができます。')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"]),
    _createVNode(InfoModal, {
      icon: "info",
      "modal-state": _unref(state).modalInfo.isOpen.detectDuplication,
      "back-button-label": _unref(t)('戻る'),
      "next-button-label": _unref(t)('重複取引を確認'),
      onOnBack: _cache[8] || (_cache[8] = ($event: any) => (_unref(openModal)('registerBusiness'))),
      onOnNext: _cache[9] || (_cache[9] = ($event: any) => (_unref(openModalByPreviousModal)('detectDuplication')))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('重複取引が検出されました')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('すでに登録されている取引が検出されました。')) + " ", 1),
        _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('重複取引を確認後、既存取引へ入力値を反映することができます。')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"]),
    _createVNode(InfoModal, {
      icon: "info",
      "modal-state": _unref(state).modalInfo.isOpen.successRegister,
      "back-button-label": _unref(t)('閉じる'),
      onOnBack: _cache[10] || (_cache[10] = ($event: any) => (_unref(closeModal)('successRegister')))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('取引情報を在庫表に登録しました')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label"]),
    _createVNode(InfoModal, {
      icon: "info",
      "modal-state": _unref(state).modalInfo.isOpen.successUpdateExistBusiness,
      "back-button-label": _unref(t)('閉じる'),
      onOnBack: _cache[11] || (_cache[11] = ($event: any) => (_unref(closeModal)('successUpdateExistBusiness')))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('既存取引に入力値を反映しました')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('既存取引に内示や販売実績など')) + " ", 1),
        _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('反映しました。')) + " ", 1),
        _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('確認は')), 1),
        _createVNode(_component_router_link, {
          class: "modal__link",
          to: "/business"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('こちら')), 1)
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(_toDisplayString(_unref(t)('のページから')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).modalInfo.isOpen.loading
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('ローディング中')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('しばしお待ちください。')), 1)
      ]),
      _: 1
    }, 8, ["modal-state"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).modalInfo.isOpen.error,
      "back-button-label": _unref(t)('閉じる'),
      onOnBack: _cache[12] || (_cache[12] = ($event: any) => (_unref(closeModal)('error')))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('通信上のエラーが起きました。')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('お手数ですが、再度お試しください。')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).modalInfo.isOpen.successRegisterWithAggregate,
      "next-button-label": _unref(t)('次へ'),
      onOnNext: _cache[13] || (_cache[13] = ($event: any) => (_unref(openModalByPreviousModal)('successRegisterWithAggregate')))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('取引を在庫表に新規登録を行います')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('下記の箇所に新しく登録されますがよろしいですか？')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          (_unref(UnmanagedBusinessService).isAggregateRow(_unref(state).selectedFileType))
            ? (_openBlock(), _createBlock(NewBaseTableContent, {
                key: 0,
                "prop-table-content-properties": _unref(state).tableInfo.modalWhenAggregateRow.tableContentProperties,
                "prop-display-objects": _unref(state).tableInfo.modalWhenAggregateRow.tableContentItems,
                "prop-loading-status": _unref(state).tableInfo.modalWhenAggregateRow.loadingState,
                "prop-table-type": 'unmanagedBusinessTypeModalWhenAggregateRow',
                class: "modal__table"
              }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"]))
            : (_openBlock(), _createBlock(NewBaseTableContent, {
                key: 1,
                "prop-table-content-properties": _unref(state).tableInfo.modal.tableContentProperties,
                "prop-display-objects": _unref(state).tableInfo.modal.tableContentItems,
                "prop-loading-status": _unref(state).tableInfo.modal.loadingState,
                "prop-table-type": 'unmanagedBusinessTypeModal',
                class: "modal__table"
              }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"]))
        ])
      ], undefined, true),
      _: 1
    }, 8, ["modal-state", "next-button-label"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).modalInfo.isOpen.registerAnnounceStartDateModal,
      "back-button-label": _unref(t)('キャンセル'),
      "next-button-label": _unref(t)('次へ'),
      onOnBack: _cache[16] || (_cache[16] = ($event: any) => (_unref(openModal)('registerBusiness'))),
      onOnNext: _cache[17] || (_cache[17] = ($event: any) => (_unref(openModalByPreviousModal)('registerAnnounceStartDateModal')))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('内示の登録開始月を選択してください')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('何年何月の内示から登録しますか？')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(SelectInput, {
              class: "modal__selection-announce__select",
              "model-value": _unref(state).modalInfo.modalState.registerAnnounceStartDate.year,
              index: 0,
              label: _unref(t)('開始年'),
              options: _unref(yearOptions),
              placeholder: _unref(t)('年'),
              "onUpdate:modelValue": _cache[14] || (_cache[14] = (e) => (_unref(state).modalInfo.modalState.registerAnnounceStartDate.year = e))
            }, null, 8, ["model-value", "label", "options", "placeholder"]),
            _createVNode(SelectInput, {
              class: "modal__selection-announce__select",
              "model-value": _unref(state).modalInfo.modalState.registerAnnounceStartDate.month,
              index: 1,
              label: _unref(t)('開始月'),
              options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
              placeholder: _unref(t)('月'),
              "onUpdate:modelValue": _cache[15] || (_cache[15] = (e) => (_unref(state).modalInfo.modalState.registerAnnounceStartDate.month = e))
            }, null, 8, ["model-value", "label", "placeholder"])
          ])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).modalInfo.isOpen.registerInventoryExecutionDateModal,
      "back-button-label": _unref(t)('戻る'),
      "next-button-label": _unref(t)('決定'),
      onOnBack: _cache[19] || (_cache[19] = ($event: any) => (_unref(openModal)('registerBusiness'))),
      onOnNext: _cache[20] || (_cache[20] = ($event: any) => (_unref(openModalByPreviousModal)('registerInventoryExecutionDateModal')))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('今回取り込みを行う在庫の年月日を指定してください。')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(AppDatePicker, {
            modelValue: _unref(state).modalInfo.modalState.inventoryExecutionDate.executionDate,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(state).modalInfo.modalState.inventoryExecutionDate.executionDate) = $event)),
            class: "modal__date-picker",
            inline: { input: true },
            "auto-apply": "",
            locale: _unref(locale),
            placeholder: _unref(t)('日付を選択'),
            "show-now-button": true,
            "now-button-label": _unref(t)('現在を選択')
          }, null, 8, ["modelValue", "locale", "placeholder", "now-button-label"])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).modalInfo.isOpen.questionUpdateExistBusiness,
      "back-button-label": _unref(t)('戻る'),
      "next-button-label": _unref(t)('入力値を反映する'),
      onOnBack: _cache[21] || (_cache[21] = ($event: any) => (_unref(openModal)('registerBusiness'))),
      onOnNext: _cache[22] || (_cache[22] = ($event: any) => (_unref(openModalByPreviousModal)('questionUpdateExistBusiness')))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('すでに存在する取引へ入力値を反映しますか？')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('すでに登録されていた取引へ入力された内示、在庫、販売実績、入荷の値を')) + " " + _toDisplayString(_unref(t)('反映することができます。')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          (_unref(UnmanagedBusinessService).isAggregateRow(_unref(state).selectedFileType))
            ? (_openBlock(), _createBlock(NewBaseTableContent, {
                key: 0,
                "prop-table-content-properties": _unref(state).tableInfo.modalWhenAggregateRow.tableContentProperties,
                "prop-display-objects": _unref(state).tableInfo.modalWhenAggregateRow.tableContentItems,
                "prop-loading-status": _unref(state).tableInfo.modalWhenAggregateRow.loadingState,
                "prop-table-type": 'unmanagedBusinessTypeModalWhenAggregateRow',
                class: "modal__table"
              }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"]))
            : (_openBlock(), _createBlock(NewBaseTableContent, {
                key: 1,
                "prop-table-content-properties": _unref(state).tableInfo.modal.tableContentProperties,
                "prop-display-objects": _unref(state).tableInfo.modal.tableContentItems,
                "prop-loading-status": _unref(state).tableInfo.modal.loadingState,
                "prop-table-type": 'unmanagedBusinessTypeModal',
                class: "modal__table"
              }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"]))
        ])
      ], undefined, true),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"])
  ]))
}
}

})